import PubSubUtils from '../utils/pubsub-utils';
import constants from '../constants';

import type { Stage } from './types';

export const publishAssignmentSubmissionDoneEvent = (data: {
  caseID: string;
  context?: string;
  isModalAction: boolean;
  isModalLaunchedFromPrimaryValue?: boolean;
  isCaseWideAction?: boolean;
  stages?: Stage[];
  stageID?: string;
}) => {
  /* publishing event to notify, the assignment is submitted */
  PubSubUtils.publish(constants.PUB_SUB_EVENTS.CASE_EVENTS.ASSIGNMENT_SUBMISSION, data);
};

export const publishEndOfAssignmentProcessingEvent = (data: {
  caseID: string;
  context?: string;
  containerItemID?: string;
}) => {
  /* publishing event to notify, case reached confirmation and routed appropriately */
  PubSubUtils.publish(constants.PUB_SUB_EVENTS.CASE_EVENTS.END_OF_ASSIGNMENT_PROCESSING, data);
};

export const publishCaseOpenedEvent = (data: {
  caseId?: string;
  context?: string;
  actionInContext: string;
  assignmentID?: string;
  caseKey?: string;
}) => {
  /* publishing event to notify, case is opened in review mode (openWorkByHandle) */
  PubSubUtils.publish(constants.PUB_SUB_EVENTS.CASE_EVENTS.CASE_OPENED, data);
};

export const publishAssignmentOpenedEvent = (data: {
  caseId?: string;
  context?: string;
  actionInContext: string;
  assignmentID?: string;
  caseKey?: string;
}) => {
  /* publishing event to notify, assignment is opened (openAssignment) */
  PubSubUtils.publish(constants.PUB_SUB_EVENTS.CASE_EVENTS.ASSIGNMENT_OPENED, data);
};

export const publishCasePreviewEvent = (data: { caseId: string; context: string }) => {
  /* publishing event to notify, case preview  */
  PubSubUtils.publish(constants.PUB_SUB_EVENTS.CASE_EVENTS.CASE_PREVIEW, data);
};

export const publishCaseAssignmentIDUpdateEvent = (data: {
  caseId?: string;
  context?: string;
  assignmentID?: string;
  isInCreateStage?: boolean;
}) => {
  /* publishing event to notify, case assignmentId for coexistence  */
  PubSubUtils.publish(constants.PUB_SUB_EVENTS.CASE_EVENTS.CURRENT_ASSIGNMENT_UPDATED, data);
};
